class FacetDrawer extends MainDrawer {
  constructor() {
    super();

    this.trigger = document.getElementById('FilterDrawerTrigger');
    if (this.trigger) {
      document.body.appendChild(this);
      this.trigger.addEventListener('click', () => {        
        this.loadAssets()
      });
    }
  }

  loadAssets() {
    if (!document.getElementById('FACETSCSS') && !document.getElementById('FACETSJS')) {
      this.classList.add('loading');
    }

    loadCss('facets')
      .then(() => {
        setTimeout(() => {
          this.classList.remove('loading');
        }, 300);
      })
      .catch((error) => {
        console.error(error);
      });
    loadScript('facets').catch((error) => {
      console.error(error);
    });
    this.openDrawer();
  }
}
customElements.define('facet-drawer', FacetDrawer);
